export const screens = {
  xs: 24, // 384px
  sm: 30, // 480px
  md: 40, // 640px
  lg: 48, // 768px
  xl: 64, // 1024px
  '2xl': 72, // 1140px
  '3xl': 90, // 1440px
  '4xl': 120, // 1920px
};
